// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__24DYO","list":"BalanceDue_list__3-Stz","listRow":"BalanceDue_listRow__2kH4X","total":"BalanceDue_total__14bah"};